<svelte:head>
   <title>{header['title'] ? header['title'] : ''}</title>
</svelte:head>

<script lang="ts">
    import { Link } from "svelte-routing";
    import { link } from "svelte-spa-router";
    import Button from "../basic/button.svelte";
    import { apiServer } from "../../constant";
    import { onMount } from "svelte";
    import { bam_host, section_pointer, step_pointer } from "../../store";


    let header = {};
    let error = null;
    onMount(async () => {
        fetch(apiServer + '/api/header?populate=header.logo&populate=header.menus.submenus', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(response => response.json())
        .then(data => {
            header = data.data.attributes.header;
        })
        .catch(e => error = e)
    });


    let menuOpen = false;
    $: handleMenuOpen

    const handleMenuOpen = () => {
        menuOpen = !menuOpen
    }
    let isTablet;

    $: dispatchResize()

    const dispatchResize = () => {
        isTablet = window.innerWidth < 1000;
    }

</script>
<svelte:window on:resize={dispatchResize}></svelte:window>
<div class="header-container" on:click={() => window.scrollTo(0,0)}>
    {#if Object.keys(header).length}
    <div class="header">
        <Link to='/home' style="margin: auto 0;">
            <img 
                src={apiServer + (header['logo'] ? header['logo'].data.attributes.url : '')}
                alt={(header['logo'] ? header['logo'].data.attributes.alternativeText : '')}
                class="logo"
            />
        </Link>
        <div class="navs">
            <div class="nav">
                <!-- Why HouseOfYards? -->
                <Link to={header['menus'][0].target} on:click={() => section_pointer.set('section1')}>{header['menus'][0].label}</Link>
                <img src="/images_icon/chevron-down-solid.svg" alt="down" />
                <div class="dropdown">
                    {#each header['menus'][0].submenus as item}
                        <Link to={header['menus'][0].target} on:click={() => {
                            section_pointer.set(item.target);
                        }}>
                            <div class="item">{item.label}</div>
                        </Link>
                    {/each}
                </div>
            </div>
            <div class="nav">
                <!-- How It Works -->
                <Link to={header['menus'][1].target} on:click={() => step_pointer.set('step1')}>{header['menus'][1].label}</Link>
                <img src="/images_icon/chevron-down-solid.svg" alt="down" />
                <div class="dropdown">
                    {#each header['menus'][1].submenus as item, i}
                        <Link to={header['menus'][1].target} on:click={() => {
                            step_pointer.set(item.target);
                        }}>
                            <div class="item">{item.label}</div>
                        </Link>
                    {/each}
                </div>
            </div>
            <!-- Pricing -->
            <div class="nav">
                <Link to={header['menus'][2].target}>{header['menus'][2].label}</Link>
            </div>
            <!-- Resources -->
            <div class="nav">
                <Link to={header['menus'][3].target}>{header['menus'][3].label}</Link>
                <img src="/images_icon/chevron-down-solid.svg" alt="down" />
                <div class="dropdown">
                    {#each header['menus'][3].submenus as submenu}
                        <a href={submenu.target} target="__blank" rel="noreferrer">
                            <div class="item">{submenu.label}</div>
                        </a>
                    {/each}
                </div>
            </div>
            <!-- Login -->
            <div class="nav" style="margin-right: 30px">
                <a href="{$bam_host}/login">{header['login_text']}</a>
            </div>
            <!-- Sign Up -->
            <Button title={header['signup_text']} on_click_func={() => { window.location.href = $bam_host + '/Register_Plan?plan_type=free&domain_name=sample'; }} />
            <div class="mobile_dropdown">
                <button 
                    class="menu"
                    on:click={(e) => {
                        handleMenuOpen()
                        // e.stopPropagation()
                    }}
                >
                    {#if menuOpen}
                        <img src="/images_icon/times.svg" style="width: 100%;" alt="menu" />
                        {:else}
                        <img src="/images_icon/bars-solid.svg" style="width: 100%;" alt="menu" />
                    {/if}
                </button>
                {#if (menuOpen && isTablet)}
                    <div class="menu-dropdown">
                        <!-- Why HouseOfYards? -->
                        <div class="nav">
                            <div>{header['menus'][0].label}</div>
                            <img src="/images_icon/chevron-down-solid.svg" alt="down" />
                            <div class="dropdown mobile-dropdown">
                                {#each header['menus'][0].submenus as item}
                                    <Link to={header['menus'][0].target} on:click={() => {
                                        section_pointer.set(item.target);
                                    }}>
                                        <div class="item">{item.label}</div>
                                    </Link>
                                {/each}
                            </div>
                        </div>
                        <!-- How It Works -->
                        <div class="nav">
                            <div>{header['menus'][1].label}</div>
                            <img src="/images_icon/chevron-down-solid.svg" alt="down" />
                            <div class="dropdown mobile-dropdown">
                                {#each header['menus'][1].submenus as item}
                                    <Link to={header['menus'][1].target} on:click={() => {
                                        step_pointer.set(item.target);
                                    }}>
                                        <div class="item">{item.label}</div>
                                    </Link>
                                {/each}
                            </div>
                        </div>
                        <!-- Pricing -->
                        <Link to={header['menus'][2].target}>
                            <div class="nav">
                                {header['menus'][2].label}
                            </div>
                        </Link>
                        <div class="nav">
                            <div>{header['menus'][3].label}</div>
                            <img src="/images_icon/chevron-down-solid.svg" alt="down" />
                            <div class="dropdown mobile-dropdown">
                                {#each header['menus'][3].submenus as submenu}
                                    <a href={submenu.target} target="__blank" rel="noreferrer">
                                        <div class="item">{submenu.label}</div>
                                    </a>
                                {/each}
                            </div>
                        </div>
                        <div class="nav">
                            <a href="{$bam_host}/login">{header['login_text']}</a>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    </div>
    {/if}
</div>
<style>
    .mobile_dropdown {
        position: relative;
    }
    .menu-dropdown {
        position: absolute;
        background-color: #fff;
        padding: 20px;
        right: 0;
        white-space: nowrap;
        top: 60px;
        box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
    }
    .menu-dropdown .nav {
        display: flex;
        padding: 10px 0;
        justify-content: space-between;
        margin: 0;
    }
    .item {
        padding: 10px 0;
        white-space: nowrap;
        cursor: pointer;
    }
    .dropdown {
        background-color: #F1F4ED;
        padding: 20px;
        position: absolute;
        top: 80px;
        right: 0;
        border-radius: 4px;
        box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
        display: none;
        z-index: 1;
    }
    .mobile-dropdown {
        top: 30px;
    }
    .menu {
        display: none;
    }
    .header-container {
        width: 100%;
        background-color: white;
        color: black;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2;
        box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
    }
    .header {
        width: 1280px;
        height: 90px;
        margin: auto;
        display: flex;
        justify-content: space-between;
    }
    .logo {
        margin: auto 0;
        height: 55px;
        cursor: pointer;
    }
    .navs {
        display: flex;
        align-items: center;
    }
    .nav {
        display: flex;
        align-items: center;
        margin-left: 20px;
        font-size: 15px;
        font-weight: 500;
        color: black;
        position: relative;
        height: 100%;
    }
    .nav:hover .dropdown {
        display: block;
    }
    .nav img {
        width: 12px;
        opacity: .6;
        margin-left: 10px;
    }
    @media (max-width: 1300px) {
        .header-container {
            padding: 0 20px;
        }
        .header {
            width: 100%;
        }
    }
    @media (max-width: 1000px) {
        .nav {
            display: none;
        }
        .menu {
            display: block;
            border: none;
            outline: none;
            background-color: #fff;
            width: 30px;
            height: 30px;
            margin-left: 20px;
        }
    }
    @media (max-width: 500px) {
        .logo {
            height: 40px;
        }
        .nav {
            font-size: 12px;
        }
    }
</style>